var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble-chart-container container",attrs:{"id":("bubble-chart-container-" + _vm.chartId)}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('svg',{attrs:{"height":"500","id":("bubble-chart-" + _vm.chartId)}})])}
var staticRenderFns = []

export { render, staticRenderFns }